import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { ChartType } from '..';

export const CustomBarChart = ({ dataset }) => {
    const { data = [], chartType = ChartType.verticalBar, indexBy = '', legends = [] } = dataset
    const legendKeys = legends?.length
        ? legends
        : Object.keys(data?.[0])?.filter(e => e !== indexBy);

    return (
        <ResponsiveBar
            data={data}
            keys={[...legendKeys]}
            indexBy={indexBy}
            layout={chartType}
            margin={{ top: 50, right: 150, bottom: 80, left: 60 }}
            padding={0.2}
            enableTotals={true}
            colors={{ scheme: 'category10' }}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legendPosition: 'middle',
                legendOffset: 32
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legendPosition: 'middle',
                legendOffset: -40
            }}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemsSpacing: 2,
                    symbolSize: 20,
                    itemDirection: 'left-to-right'
                }
            ]}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            groupMode="stacked"
        />
    )
}